import router from '../../app/router';
import Calendar from './index.vue';

const routes = [
  {
    path: '/pages/calendar',
    name: "pages/calendar",
    component: Calendar,
    meta: {
      title: "选择出发日期"
    }
  }
];

router.addRoutes(routes);



// WEBPACK FOOTER //
// ./src/pages/calendar/install.js